module.exports = __webpack_public_path__ + "img/En_cofig.04be67a2.jpg";